import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';

import GlobalStyle from './styles/global';
import AppProvider from './hooks/index';
// import ChatwootWidget from './components/Chatwoot';

const App: React.FC = () => (
  <BrowserRouter>
    <AppProvider>
      <Routes />
    </AppProvider>
    {/* <ChatwootWidget /> */}
    <GlobalStyle />
  </BrowserRouter>
);

export default App;
